<template>
	<section class="faq-contact-card">
		<h2 class="faq-contact-card__title">{{ $t('components.faq_page.contact_title') }}</h2>
		<p class="faq-contact-card__subtitle">{{ $t('components.faq_page.contact_subtitle') }}</p>

		<ul class="faq-contact-card__list">
			<li>
				<a href="tel:+48794500550" rel="nofollow" class="faq-contact-card__link">
					<GlobalIcon name="call" class="faq-contact-card__icon" :width="20" :height="20" />
					+48 794 500 550
				</a>
			</li>
			<li>
				<a href="mailto:rezerwacje@carfree.pl" rel="nofollow" class="faq-contact-card__link">
					<GlobalIcon name="sms" class="faq-contact-card__icon" :width="20" :height="20" />
					rezerwacje@carfree.pl
				</a>
			</li>
		</ul>

		<ButtonOutlined class="faq-contact-card__cta" :to="localePath('contact')">
			{{ $t('components.faq_page.contact_cta') }}
		</ButtonOutlined>
	</section>
</template>

<script setup lang="ts">
const localePath = useLocalePath()
</script>

<style lang="scss" src="./FaqContactCard.scss"></style>
